import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { Alert, Card } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {myFirestore} from '../../services/firebase'
import images from '../../Themes/Images'
import * as Yup from 'yup';


import './profile.css';


// class SignUp extends Component {
//   state = {
//     email: '',
//     password: '',
//     username: '',
//     isCounselor: false,
//   }
//   onChange = (value) => {
//     console.log(value && value.format(format));
//   }

//   handleCheckboxChange = (e) => {
//     const target = e.target
//     const checked = target.checked
//     this.setState({
//       [e.target.name]: checked,
//     });
//   }
//   handleChange = (e) => {
//     this.setState({
//       [e.target.id]: e.target.value,
//     })
//   }
//   handleSubmit = (e) => {
//     e.preventDefault();
//     this.props.signUp(this.state);
//   }
//   render() {
//     const { auth, authError } = this.props;
//     if (auth.uid) return <Redirect to='/' />
//     return (
//       <Container className="auth-container" fluid>
//         <Card className="auth-card">

//           <Form onSubmit={this.handleSubmit} style={{ padding: '1rem' }}>
//             <h3>Sign Up</h3>
//             <Form.Group controlId="formBasicEmail">
//               <label htmlFor="email">Email</label>
//               <input className="form-control" type="email" id='email' placeholder="Enter email" onChange={this.handleChange} />
//             </Form.Group>
//             <Form.Group controlId="formBasicPassword">
//               <label htmlFor="password">Password</label>
//               <input className="form-control" type="password" id='password' placeholder="Enter password" onChange={this.handleChange} />
//             </Form.Group>
//             <Form.Group>
//               <label htmlFor="UserName">Username</label>
//               {/* <input className="form-control" type="text" id='username' placeholder="Enter Username" onChange={this.handleChange} /> */}

//               <InputGroup className="mb-2">

//                 <InputGroup.Prepend>
//                   <InputGroup.Text>@</InputGroup.Text>
//                 </InputGroup.Prepend>
//                 <FormControl id="username" placeholder="Enter Username" onChange={this.handleChange} />
//               </InputGroup>
//             </Form.Group>
//             <Form.Group controlId="formHorizontalCheck">

//               <Form.Check name="isCounselor" label="Register as Peer Counselor" onChange={this.handleCheckboxChange} />

//             </Form.Group>

//             {this.state.isCounselor ?

//               <Form.Group>
//                 <label > Pick a Slot</label><br></br><br></br>
//             From {"    "}

//                 <TimePicker
//                   showSecond={false}
//                   defaultValue={now}

//                   onChange={this.onChange}
//                   format={format}
//                   use12Hours
//                   inputReadOnly
//                 />
//                 {"    "} to {"    "}
//                 <TimePicker
//                   showSecond={false}
//                   defaultValue={now}

//                   onChange={this.onChange}
//                   format={format}
//                   use12Hours
//                   inputReadOnly
//                 />
//               </Form.Group>
//               : null
//             }
//             <button type="submit" className="btn button  btn-block">Sign Up</button>

//             <br />
//             <div className="error">
//               {authError ? <p>{authError}</p> : null}
//             </div>

//           </Form>
//         </Card>
//       </Container>
//     )
//   }
// }


class Profile extends React.Component {

  state={
    show:true
  }
  handleClose = ()=> this.setState({show:false})


  handleSubmit = (values, {
    setSubmitting
  }) => {

    alert(JSON.stringify(values, null, 2));

    setSubmitting(false);

    return;
  }


  render() {
    const { auth, authError,profile } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <>
        <Formik
          initialValues={{
            gender: '',
            username: '',
            age: '',
            email: '',
            
            
            qualification: '',
            occupation: '',
            familymembers: '',
            relationshipstatus: '',
            livingsituation: '',
            livingwith: '',
            isFirsttime: true,
            listofpasttherapy: '',
            isCounselor: false,
            from: '',
            to: '',
            
            
          }}
          validationSchema={Yup.object().shape({
            gender: Yup.string(),

            username: Yup.string(),
              
            isConsent: Yup.bool(),
              
            isCounselor: Yup.bool(),
            
            
            age: Yup.string()
              
            ,
            qualification: Yup.string()
              ,

            occupation: Yup.string()
              ,

            familymembers: Yup.string()
              ,



            
          })}
          onSubmit={fields => {


            myFirestore
            .collection('users')
            .doc(auth.uid)
            .set({
              
                username: fields.username?fields.username:profile.username,
              gender: fields.gender?fields.gender:profile.gender,
              age: fields.age?fields.age:profile.age,
              
              qualification: fields.qualification?fields.qualification:profile.qualification,
              occupation: fields.occupation?fields.qualification:profile.qualification,
              familymembers: fields.familymembers?fields.familymembers:profile.familymembers,
              relationshipstatus: fields.relationshipstatus?fields.relationshipstatus:profile.relationshipstatus,
              livingsituation: fields.livingsituation?fields.livingsituation:profile.livingsituation,
              livingwith: fields.livingwith?fields.livingwith:profile.livingwith,
              
              listofpasttherapy: fields.listofpasttherapy?fields.listofpasttherapy:profile.listofpasttherapy,
       
            },
            { merge: true })
            .then(() => {
                 
                 this.props.history.push('/')

                 
            })
            .catch(err => {
               
            })

          }}

        >
          {({ errors, touched, values,handleChange }) => (



            <Container className="auth-container" fluid>
              

              <Card className="auth-card">
               
                <h2 style={{ color: 'black' ,textAlign:'center'}} ><img src={images.ic_default_avatar} alt=''/></h2>
                
                
                  <Form>

                    <div className="error">
                      {authError ?
                        <Alert variant="danger">

                          <Alert.Heading>Error while  Up </Alert.Heading>
                          <p>
                            {authError}
                          </p>
                        </Alert>

                        : null}

                    </div>

                    

                    
                    <div className="">
                      <div className="form-group col">
                        <label htmlFor="username">Username</label>
                       
                        
                        <Field name="username" placeholder={profile.username} onChange={handleChange} type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                        <ErrorMessage name="username" component="div" className="invalid-feedback" />
                      </div>


                      
                    </div>
                    
                    {values.isCounselor ? null: this.notcounselor(values, errors, touched,profile)}
                    

                    <div className="row justify-content-center">

                      <button type="submit" className="btn button mr-2 ">Update </button>
                      
                    </div>

                  </Form>
                
              </Card>

            </Container>





          )}

        </Formik>
      </>
    );
  }
  notcounselor(values, errors, touched,profile) {
    return <div>
      <div className="">
        {/* <div className="form-group col">
          <label>Gender</label>
          <Field name="gender" as="select" className={'form-control' + (errors.gender && touched.gender ? ' is-invalid' : '')}>
            <option value=""></option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Others">Others</option>

          </Field>
          <ErrorMessage name="gender" component="div" className="invalid-feedback" />
        </div> */}
        <div className="form-group col">
          <label htmlFor="gender">Gender</label>
          <Field name="gender" type="text" placeholder={profile.gender} className={'form-control' + (errors.gender && touched.gender ? ' is-invalid' : '')} />
          <ErrorMessage name="gender" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group col">
          <label htmlFor="age">Age</label>
          <Field name="age" type="text" placeholder={profile.age} className={'form-control' + (errors.age && touched.age ? ' is-invalid' : '')} />
          <ErrorMessage name="age" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group col">
          <label htmlFor="qualification">Qualification</label>
          <Field name="qualification" type="text" placeholder={profile.qualification} className={'form-control' + (errors.qualification && touched.qualification ? ' is-invalid' : '')} />
          <ErrorMessage name="qualification" component="div" className="invalid-feedback" />
        </div>
      </div>
      <div className="">


        <div className="form-group col">
          <label htmlFor="occupation">Occupation</label>
          <Field name="occupation" type="text" placeholder={profile.occupation} className={'form-control' + (errors.occupation && touched.occupation ? ' is-invalid' : '')} />
          <ErrorMessage name="occupation" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group col">
          <label htmlFor="familymembers">Family Members</label>
          <Field name="familymembers" type="familymembers" placeholder={profile.familymembers} className={'form-control' + (errors.familymembers && touched.familymembers ? ' is-invalid' : '')} />
          <ErrorMessage name="familymembers" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group col">
          <label htmlFor="relationshipstatus">Relationship Status</label>
          <Field name="relationshipstatus" type="text" placeholder={profile.relationshipstatus} className={'form-control' + (errors.relationshipstatus && touched.relationshipstatus ? ' is-invalid' : '')} />
          <ErrorMessage name="relationshipstatus" component="div" className="invalid-feedback" />
        </div>
      </div>
      <div className="">
        <div className="form-group col">
          <label htmlFor="livingsituation">Current living situation </label>
          <Field name="livingsituation" type="text" placeholder={profile.livingsituation} className={'form-control' + (errors.livingsituation && touched.livingsituation ? ' is-invalid' : '')} />
          <ErrorMessage name="livingsituation" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group col">
          <label htmlFor="livingwith">Currently living with</label>
          <Field name="livingwith" type="text" placeholder={profile.livingwith} className={'form-control' + (errors.livingwith && touched.livingwith ? ' is-invalid' : '')} />
          <ErrorMessage name="livingwith" component="div" className="invalid-feedback" />
        </div>


      </div>

      

    </div>
  }
  
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError,
    profile: state.firebase.profile
  }
}



export default connect(mapStateToProps)(Profile)
